// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  AccidentsReportsAreaId,
  AccidentsReportsAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  AccidentsReportsAreaNavigation,
  AccidentsReportsAreaNavigationIcon,
} from './AccidentsReportsAreaNavigation'

const LazyAccidentsReportsComponent = lazy(
  () => import('./AccidentsReportsArea'),
)

const AccidentsReportsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAccidentsReportsComponent />
  </SuspenseLoadingWrapper>
)

export const AccidentsReportsArea = {
  id: AccidentsReportsAreaId,
  requiredRight: BoumRight.REPORT_ACCIDENT_AREA,
  Icon: AccidentsReportsAreaNavigationIcon,
  NavigationComponent: AccidentsReportsAreaNavigation,
  route: {
    path: AccidentsReportsAreaRoutes.route,
    component: AccidentsReportsComponent,
  },
}
